import { render } from "./MyInvoices.vue?vue&type=template&id=38f0a884&scoped=true"
import script from "./MyInvoices.vue?vue&type=script&lang=js"
export * from "./MyInvoices.vue?vue&type=script&lang=js"

import "./MyInvoices.vue?vue&type=style&index=0&id=38f0a884&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f0a884"]])

export default __exports__